import React, { Component } from "react"
import { COLORS } from '../../utilities/colours'
import { Container, CardGroup, Card, Grid, GridColumn, Input, Confirm } from 'semantic-ui-react'

class MerchandiseConsumer extends Component {
    state = { gameItems: [], selectedItem: {}, isSearching: false, searchString: '', showConfirmCheckout: false, confirmationCheckoutStr: '' }

    componentDidMount() {
        if (this.props.savedDict) { 
            const { gameItems } = this.props.savedDict
            this.setState({ gameItems: gameItems || [] })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.savedDict.gameItems !== this.props.savedDict.gameItems) {
            const { gameItems } = this.props.savedDict
            this.setState({ gameItems: gameItems || [] })
        }
    }

    renderCards() {
        const data = this.state.isSearching ? this.state.gameItems.filter(item => item.nameConsumer.header?.toLowerCase().includes(this.state.searchString.toLowerCase())) : this.state.gameItems
        if (!data || data.length === 0 || data === undefined) return <div>No items available</div>
        var rows = []
        var doubleRechargeRows = []
        for (const [i, item] of data.entries()) {
            if (item.isHiddenConsumer) continue
            (item.isDoubleRecharge ? doubleRechargeRows : rows).push(

                <Card key={i} link raised onClick={() => this.handleCardClicked(item)} 
                    style={{ width: "150px", margin: "10px", background: this.isSelected(item) ? COLORS.CARD_SELECTED : COLORS.CARD_DEFAULT, color: this.isSelected(item) ? COLORS.TEXT_WHITE : COLORS.TEXT_WHITE, 
                    transition: "all 0.3s ease", boxShadow: "0 4px 8px rgba(0,0,0,0.3)" }} className="diamond-card">
                    <Card.Content>
                        <Card.Header style={{ fontSize: '1.2em' }}>{item.nameConsumer.header.replace('Diamonds', '💎')}</Card.Header>
                        <Card.Meta style={{ marginTop: 3, color: this.isSelected(item) ? COLORS.TEXT_WHITE : COLORS.TEXT_DIM, fontSize: '1em' }}>
                            {item.nameConsumer.subheader.replace('Diamonds', '💎')}
                        </Card.Meta>
                        <Card.Description style={{ marginTop: 10, fontWeight: "bold", fontSize: '1.1em' }}>
                        {'$' + roundUp2DP(this.getPrice(item.cost, item.isDiscountedConsumer, item.discountRateConsumer)).toFixed(2)}
                        </Card.Description>
                    </Card.Content>
                </Card>
            )
        }
        return (
            <div>
                <CardGroup style={{ marginTop: 20 }} centered doubling stackable itemsPerRow={6}>{rows}</CardGroup>
                { doubleRechargeRows.length > 0 ? <div>
                <h4 style={{ marginTop: 30 }}>Double Recharge ⚡⚡</h4>
                <CardGroup style={{ marginTop: 10 }} centered doubling stackable itemsPerRow={6}>{doubleRechargeRows}</CardGroup></div> : null }
            </div>
        )
    }

    render() {
        return (
            <Container>
                <Grid style={{ marginTop: 0 }}>
                    <GridColumn floated='left' width={5}><h2>{this.props.savedDict.name}</h2></GridColumn>
                    <GridColumn width={6}><Input fluid action={{ icon: 'search' }} placeholder='Search product...' onChange={this.handleChangeSearchField}/></GridColumn>
                </Grid>
                {this.renderCards()}
                <Confirm open={this.state.showConfirmCheckout} onCancel={() => this.handleCheckoutCancel()} onConfirm={() => this.handleCheckoutConfirm()} header="Confirmation" content={this.state.confirmationCheckoutStr} 
                        cancelButton="Cancel" confirmButton="Place Order"/>
            </Container>
        )
    }

    isSelected(item) {
        const { selectedItem } = this.state
        if (selectedItem.nameSupplier === item.nameSupplier) return true
        else return false
    }

    getPrice(cost, discounted, discountRate) {
        const markup = (discounted) ? (Number(this.props.markup) - Number(discountRate)) : Number(this.props.markup)
        return Number(cost) + (markup/100 * Number(cost))
    }

    handleChangeSearchField = e => {
        if (e.target.value === "") this.setState({ isSearching: false })
        else this.setState({ isSearching: true, searchString: e.target.value })
    }

    handleCardClicked(item) {
        this.setState({ selectedItem: item }, this.props.selectedItem(item))
    }

    handleCheckoutConfirm() {
        this.setState({ showConfirmCheckout: false }, () => this.props.placeOrder(this.state.selectedItem))
    }

    handleCheckoutCancel() {
        this.setState({ showConfirmCheckout: false })
    }
}

function roundUp2DP(num) {
    return Math.ceil(num * 100) / 100
}

export default MerchandiseConsumer